import moment from "moment";

// creates html view for images
export const createMarkup = (html: string) => {
  return { __html: html };
};

// group objects of an array by specific key
export const groupBy = (array, key) => {
  return array.reduce((temp, obj) => {
    if (!obj[key]) return temp;
    const keyValue = obj[key];
    temp[keyValue] = (temp[keyValue] || []).concat(obj);
    return temp;
  }, {});
};

// group by key
export const groupByKey = (array: any[], key: string) => {
  return array.reduce((temp, obj) => {
    if (!obj[key]) return temp;
    const keyValue = obj[key];
    temp[keyValue] = (temp[keyValue] || []).concat(obj);
    return temp;
  }, {});
};
export const getDatesOfWeek = (month: string) => {
  console.log({ month });
  const currYear = moment().year();
  let m = moment(month).month();
  let currMonth = `${m < 10 ? "0" : ""}${m}`;
  const endDate = moment(`${currYear}-${currMonth}-01`).endOf("month").date();
  let d = `${currYear}-${currMonth}`;
  const result: { start_date: string; end_date: string }[] = [
    { start_date: `${d}-01`, end_date: `${d}-07` },
    { start_date: `${d}-08`, end_date: `${d}-14` },
    { start_date: `${d}-15`, end_date: `${d}-21` },
    {
      start_date: `${d}-22`,
      end_date: `${d}-${endDate < 10 ? "0" : ""}${endDate}`,
    },
  ];
  return result;
};

export const filterMonths = () => {
  const months = [
    // { name: "Jan", id: 1 },
    // { name: "Feb", id: 2 },
    // { name: "Mar", id: 3 },
    // { name: "Apr", id: 4 },
    { name: "May", id: 5 },
    { name: "Jun", id: 6 },
    { name: "Jul", id: 7 },
    { name: "Aug", id: 8 },
    { name: "Sep", id: 9 },
    { name: "Oct", id: 10 },
    { name: "Nov", id: 11 },
    { name: "Dec", id: 12 },
  ];
  const currentMonth = moment().month() + 1;
  const filteredMonths = months.filter(e => e.id <= currentMonth);
  // console.log("Current month: ", currentMonth, " Filtered: ", filteredMonths);
  return filteredMonths;
};


export const getDataRangeByWeekNo = (weekNo: number) => {
  let startDate: string = "";
  let endDate: string = "";
  if(weekNo < moment().week()){
    const year = weekNo > moment().week() ? (+moment().format('YYYY')) : +moment().format('YYYY');
    startDate = moment().year(year).week(weekNo).startOf('week').add(1, "d").format("YYYY-MM-DD");
    endDate = moment().year(year).week(weekNo).endOf('week').add(1, "d").format("YYYY-MM-DD");
  }
  else{
    const week = weekNo > moment().week() ? weekNo + 1 : weekNo
    const year = weekNo > moment().week() ? (+moment().format('YYYY') - 1) : +moment().format('YYYY')
     startDate = moment().year(year).week(week - 1).startOf('week').add(1, "d").format("YYYY-MM-DD");
     endDate = moment().year(year).week(week - 1).endOf('week').add(1, "d").format("YYYY-MM-DD");
  }
  // if (weekNo < 16) {
  //   startDate = moment().day("monday").year(+moment().format('YYYY')).week(weekNo).format("DD/MM/YYYY");
  //   endDate = moment().day("sunday").year(+moment().format('YYYY')).week(weekNo).format("DD/MM/YYYY");
  // } else {
  //   let lastYear = Number(moment().format("YYYY")) - 1;
  //   startDate = moment().day("monday").year(lastYear).week(weekNo).format("DD/MM/YYYY");
  //   endDate = moment().day("sunday").year(lastYear).week(weekNo).format("DD/MM/YYYY");
  // }
  // console.log("Week nO", weekNo, "=>", startDate, endDate)
  return {
    startDate,
    endDate
  }
}